import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class InternalSendEmailService {
  constructor(private http: HttpClient) {}

  /**
   * @description Takes in the template name and returns details per environment
   * @requires EMAIL_TEMPLATE_NM
   * @returns SENDER_ADDR, SUBJECT_TXT
   */
  getEmailTemplateByNm(emailTemplateNm) {
    return this.http.get(`/api/SendEmail/getEmailTemplateByNm`, {
      params: { type: emailTemplateNm },
      responseType: "json"
    });
  }

  /**
   * @description Takes in the consultant ID of the internal user to send an email to as they have been assigned one or many requests to review.
   * @requires consultant_id
   * @returns Error if any.
   */
  requestAssigned(data) {
    return this.http.get(`/api/internalsendemail/requestAssigned`, {
      params: { type: data },
      responseType: "json",
      observe: "response"
    });
  }

  /**
   * @description Takes in the person_id for the student that the decision was made on. Send an email to all the staff at the organization.
   * @requires person_id
   * @returns Error if any.
   */
  decisionMade(data) {
    return this.http.post(`/api/internalsendemail/decisionMade`, data, {
      observe: "response"
    });
  }

  /**
   * @description Takes in the accomms pin for the student that the decision was made on. Send an email to the reviewer that an error occured.
   * @requires consultant_id
   * @required taa_pin
   * @returns Error if any.
   */
  reviewSubmitError(data) {
    return this.http.post(`/api/internalsendemail/reviewSubmitError`, data, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/common/services/internalsendemail.service.ts